// extracted by mini-css-extract-plugin
export default {"heroContainer":"HeroSection_heroContainer__FeZzX","sliderTrack":"HeroSection_sliderTrack__mTPhc","heroImage":"HeroSection_heroImage__0YEL8"};